import React, { Fragment, useEffect } from "react";
import { useState } from "react";
import { GrClose } from "react-icons/gr";
import theme from "../../../../Utils/theme";
import barIcon from "../../../../assets/icon/baricon.svg";

// import component 👇
import Drawer from "react-modern-drawer";

//import styles 👇
import "react-modern-drawer/dist/index.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Fontstyling from "../../comman";

const Leftdrawer = ({ open, setOpen, data, marginTop }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeLeftMenu, setActiveLeftMenu] = useState(null);

  useEffect(() => {
    if (location?.pathname.endsWith("/EmpoweRx")) {
      setActiveLeftMenu(1);
    }
  }, [location.pathname]);

  const toggleLeftMenu = (id) => {
    setActiveLeftMenu(activeLeftMenu === id ? null : id);
  };
  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <>
      <Drawer
        open={open}
        onClose={toggleDrawer}
        direction="left"
        className=""
        duration="500"
        style={{ width: "210px", marginTop: marginTop }}
      >
        <div className="d-flex flex-column w-100">
          <div className="ms-2 pt-1 fs-4">
            <GrClose size={20} onClick={toggleDrawer} />
          </div>
          <hr className="mt-1" />
          <div style={{ overflow: "auto", height: "450px" }}>
            <ul className="p-0 gap-2 mb-0">
              {data?.map(({ id, title, pathName, submenu }, index) => (
                <Fragment key={index}>
                  <li
                    className="d-flex align=items-center ps-1 py-2"
                    key={index}
                  >
                    <img
                      src={barIcon}
                      width="24  "
                      alt="barIcon"
                      className="me-3"
                    />
                    <NavLink
                      to={pathName}
                      className="text-wrap"
                      style={({ isActive }) => ({
                        ...Fontstyling.sidebarheading,
                        textDecoration: "none",
                        color:
                          isActive ||
                          (location.pathname.endsWith("/HUBExperience") &&
                            id === 1) ||
                          (location.pathname.endsWith("/utilitydata") &&
                            id === 1) ||
                          (location.pathname.endsWith("/clientdata") &&
                            id === 1) ||
                          (location.pathname.endsWith("/report&extract") &&
                            id === 1) ||
                          (location.pathname.endsWith("/servicerequest") &&
                            id === 1) ||
                          // (location.pathname.endsWith("/cedargateadmin") &&
                          //   id === 1) ||
                            (location.pathname.endsWith("/planinsightsadmin") &&
                            id === 1) ||
                          (location.pathname.endsWith("/EmpoweRx") && id === 1)
                            ? theme.SECONDARY_NEARLY_BLACK
                            : theme.SECONDARY_CHARCOAL_GRAY,
                      })}
                      onClick={() => {
                        if (submenu) {
                          toggleLeftMenu(id)
                        } else {
                          toggleDrawer();
                        }
                      }}
                    >
                      {title}
                    </NavLink>
                  </li>
                  {submenu && activeLeftMenu === id  && (
                      <div className="submenu-container">
                        <ul className="submenu p-0 gap-1 d-grid">
                          {submenu.map(({ smId, title, pathName}) => (
                            <li
                              key={smId}
                              className="d-flex align-items-center py-2"
                              style={{ paddingLeft: '3.8rem' }}
                            >
                              <NavLink
                                to={pathName}
                                className="text-wrap"
                                style={({ isActive }) => ({
                                  ...Fontstyling.sidebarheading,
                                  textDecoration: "none",
                                  lineHeight: "20px",
                                  color:
                                    isActive ||
                                      (location.pathname.endsWith("/EmpoweRx") || location.pathname.endsWith("/EmpoweRxRFP")) && id === 1 && smId === 1
                                      || (location.pathname.endsWith("RxBlockPricing") && id === 2 && smId === 1)
                                      ? theme.SECONDARY_NEARLY_BLACK
                                      : theme.SECONDARY_CHARCOAL_GRAY,
                                })}
                                onClick={() => toggleDrawer()}
                              >
                                {title}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                </Fragment>
              ))}
            </ul>
          </div>
        </div>
      </Drawer>
      {/* {!isOpen && <button onClick={toggleDrawer}>open</button>} */}
    </>
  );
};

export default Leftdrawer;
